const SoldOutBadge = () =>
  <img
    className="sold-out-badge"
    src={`${window.env.assetHost}assets/images/offers/sold-out.svg`}
  />

export default SoldOutBadge
